import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRequest as fetchCard } from "../../store/card/actions";
import { fetchRequest as fetchCardTypes } from "../../store/cardType/actions";
import { ApplicationState } from "../../store";
import CardTable from "./cardTable/CardTable";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import PageLayout from "../PageLayout";
import { History, LocationState } from "history";

export default function Card() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCard(null));
    dispatch(fetchCardTypes(null));
  }, []);

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.card
  );
  const card = data?.data || [];

  const actions = [
    {
      label: "Add new Card Prefix",
      handler: (history: History<LocationState>) => history.push("/card/new"),
    },
    {
      label: "Import Card Prefix",
      handler: (history: History<LocationState>) =>
        history.push("/card/import"),
    },
  ];
  return (
    <PageLayout heading="Card Prefix" actions={actions} entity="Card">
      {loading ? <ProgressIndicator /> : <CardTable cardData={card} />}
    </PageLayout>
  );
}
